var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{staticClass:"mb-5",staticStyle:{"margin-top":"-30px"},attrs:{"align":"right"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((this.languages),function(l){return _c('b-tab',{key:l.locale,attrs:{"title":l.locale},on:{"click":function($event){return _vm.setLanguage(l.locale)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }